import { ExerciseResponse } from './ExerciseResponse.js';

const _items = Symbol();

export class ExerciseResponses {
	constructor(...items) {
		this[_items] = [];

		this.add(...items);
	}
	//iterator protocol support
	*iterator() {
		for(let key in this[_items]) {
			let value = this[_items][key];
			yield value;
		}
	}
	//iterable protocol support
	[Symbol.iterator]() {
		return this.iterator();
	}
	add(...items) {
		items.forEach((item, index) => {
			if(!(item instanceof ExerciseResponse))
				throw new TypeError(`argument at index ${index} must be an instance of ExerciseResponse.`);
		});
		this[_items].push(...items);
	}
	get(index) {
		if(!Number.isInteger(index))
			throw new TypeError('index must be an integer.');
		
		return this[_items][index];
	}
	get length() {
		return this[_items].length;
	}
	get firstDay() {
		return this[_items].reduce((p, c) => {
			if(!p) return c;
			return p.answerDate < c.answerDate ? p : c;
		}, null);
	}
	get lastDay() {
		return this[_items].reduce((p, c) => {
			if(!p) return c;
			return p.answerDate > c.answerDate ? p : c;
		}, null);
	}
	toJSON() {
		return this[_items].slice(0);
	}
	static fromArray(arr) {
		if(!Array.isArray(arr))
			throw new TypeError('arr must be an array.');
		return new this(
			...arr.map(v => ExerciseResponse.fromObject(v))
		);
	}
}